import React from 'react';
import { hrs } from './fabDashUtils';

const Panel = ({ title, range, empty, children }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm">
    <div className="px-4 py-3 border-b border-slate-200">
      <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
      <p className="text-xs text-slate-500">{range}</p>
    </div>
    {empty ? <p className="px-4 py-6 text-sm text-slate-500 text-center">{empty}</p> : <div className="divide-y divide-slate-100">{children}</div>}
  </div>
);

export const WeekPanels = ({ week }) => {
  const range = `${week.start} → ${week.end}`;
  const maxEmp = Math.max(1, ...week.by_employee.map((e) => e.total));
  const maxWo = Math.max(1, ...week.by_wo.map((w) => w.total_hours));
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="fab-week-panels">
      <Panel title="This week — hours by person" range={range} empty={week.by_employee.length === 0 && 'No hours logged this week yet'}>
        {week.by_employee.map((e) => (
          <div key={e.employee_name} className="px-4 py-2 grid grid-cols-[1fr_auto] gap-x-3 items-center" data-testid={`week-emp-${e.employee_name.replace(/\s+/g, '-').toLowerCase()}`}>
            <div className="min-w-0">
              <p className="text-sm text-slate-900 truncate">{e.employee_name}</p>
              <div className="h-1.5 rounded-full bg-slate-100 mt-1 overflow-hidden"><div className="h-full bg-blue-600 rounded-full" style={{ width: `${(e.total / maxEmp) * 100}%` }} /></div>
            </div>
            <p className="text-sm font-bold text-slate-900 text-right">{hrs(e.regular)}{e.overtime > 0 && <span className="text-amber-600 text-xs font-semibold"> +{hrs(e.overtime)} OT</span>}</p>
          </div>
        ))}
      </Panel>
      <Panel title="This week — hours by work order" range={range} empty={week.by_wo.length === 0 && 'No hours logged this week yet'}>
        {week.by_wo.map((w) => (
          <div key={w.work_order_number} className="px-4 py-2 grid grid-cols-[1fr_auto] gap-x-3 items-center">
            <div className="min-w-0">
              <p className="text-sm truncate"><span className="font-mono text-blue-700 font-semibold">{w.work_order_number}</span> <span className="text-slate-700">{w.customer}</span></p>
              <div className="h-1.5 rounded-full bg-slate-100 mt-1 overflow-hidden"><div className="h-full bg-slate-100 rounded-full" style={{ width: `${(w.total_hours / maxWo) * 100}%` }} /></div>
            </div>
            <p className="text-sm font-bold text-slate-900 text-right">{hrs(w.total_hours)}</p>
          </div>
        ))}
      </Panel>
    </div>
  );
};
